<template>
    <div class="chart-block">
        <div class="chart-canvas-wrap">
            <Chart
                v-if="hasData"
                type="bar"
                :data="chartData"
                :options="chartOptions"
                style="width:100%; height:100%;"
            />
            <div v-else class="chart-empty">Sem dados</div>
        </div>

    </div>
</template>

<script>
import SafeChart from '@/components/SafeChart.vue';

export default {
    name: 'HorizontalBarEtapas',
    components: { Chart: SafeChart },
    props: {
        rawData:  { type: Object, required: true, default: () => ({}) },
        colorMap: { type: Object, required: true }
    },
    computed: {
        hasData() {
            return this.rawData?.labels?.length && this.rawData?.datasets?.length;
        },
        chartData() {
            if (!this.hasData) return {};
            const datasets = this.rawData.datasets.map(ds => ({
                ...ds,
                backgroundColor: this.colorMap[ds.label] || '#6b7280',
                borderColor: 'transparent',
                borderRadius: 3,
                barPercentage: 0.9,
                categoryPercentage: 0.85,
            }));
            return { ...this.rawData, datasets };
        },
        chartOptions() {
            return {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                animation: { duration: 350 },
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            color: '#9ca3af',
                            usePointStyle: true,
                            pointStyle: 'circle',
                            padding: 16,
                            font: { size: 11 }
                        }
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        backgroundColor: 'rgba(20,20,20,0.95)',
                        titleColor: '#e6edf3',
                        bodyColor: '#8b949e',
                        cornerRadius: 6,
                        padding: 8,
                    }
                },
                scales: {
                    x: {
                        stacked: true,
                        grid: { color: 'rgba(255,255,255,0.06)', drawBorder: false },
                        ticks: { color: '#8b949e', font: { size: 11 } }
                    },
                    y: {
                        stacked: true,
                        grid: { display: false },
                        ticks: { color: '#c9d1d9', font: { size: 11 } }
                    }
                }
            };
        }
    }
}
</script>

<style scoped>
.chart-block {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* Wrapper com altura fixa — Chart.js precisa de um pai com altura definida */
.chart-canvas-wrap {
    height: 260px;
    position: relative;
    width: 100%;
}

.chart-empty {
    height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
}
</style>
